import { notificationActions } from '../actions/notification.actions';
import { NotificationModal } from '../modal/notification';
const initialState = {
    notifications: [] as NotificationModal[],
    card_html: '',
    notification_msg: '',
    home_va_data:{},
    va_details:[]
};

/**
 * Reducer function to manage notification-related state updates.
 * 
 * @param {Object} state - The current state of notifications, defaulting to initialState.
 * @param {Object} action - The action dispatched containing a type and payload to update the state.
 * @returns {Object} - The updated state based on the action type.
 * 
 * Handles the following actions:
 * - SET_NOTIFICATIONS: Updates the state with a new list of notifications.
 * - UPDATE_NOTIFICATION: Modifies an existing notification in the state.
 * - SET_CARD_HTML: Sets the card HTML content in the state.
 * - SET_NOTIFICATION_MESSAGE: Updates the notification message in the state.
 * - SET_HOME_VA_DATA: Sets the home virtual assistant data in the state.
 * - SET_VA_DETAILS: Updates the virtual assistant details in the state.
 * - Default: Returns the current state if action type is unrecognized.
 */

export const notificationState = (state = initialState, action: any) => {
    switch (action.type) {
        case notificationActions.SET_NOTIFICATIONS:
            return {...state, ...{ notifications: action.payload.notifications }};

        case notificationActions.UPDATE_NOTIFICATION:{
            let notifications = state.notifications.slice();
            let updated_notification = action.payload.notification;
            let index = notifications.findIndex(nf=>nf.id === updated_notification.id);
            if(index !== -1){
                notifications[index] = updated_notification;
            }
            return {...state, ...{ notifications: notifications }};
        }
        case notificationActions.SET_CARD_HTML:
            return {...state, ...{ card_html: action.payload.card_html }};

        case notificationActions.SET_NOTIFICATION_MESSAGE:
            return {...state, ...{ notification_msg: action.payload.notification_msg }};

        case notificationActions.SET_HOME_VA_DATA:
            return { ...state, ...{ home_va_data: action.payload.home_va_data }};

        case notificationActions.SET_VA_DETAILS:
            return {  ...state, ...{ va_details: action.payload.va_details}};

        default:
            return state;
    }
};
